<template>
	<div>
		<div class="main">
            <div class="container">
                <div class="row center middle onboarding-wrap">
					<div class="col-lg-4 col-sm-6 col-md-8 col-xs-11">
						<div class="onboarding-logo">
							<img src="/static/images/logo-onboarding.svg" alt="" />
						</div>
						<form action="#" class="form" @submit.prevent>
							<div class="row">
								<div class="col-lg-12">
									<input-widget
									v-model.trim="email"
									type="email"
									:placeholder="$t('label.email')"
									validate="required|email"
									></input-widget>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-12">
									<input-widget
									v-model.trim="password"
									type="password"
									:placeholder="$t('label.password')"
									validate="required|min:6"
									></input-widget>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-12">
									<br />
									<button :class="{ 'button-full': true, 'loading': loading }" @click="validate">{{ $t("button.login") }}</button>
								</div>
							</div>
						</form>
	                    <p class="onboarding-link">
	                        <router-link to="forgot-password">{{ $t("message.forgottenPassword") }}</router-link>
	                    </p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import auth from '@/auth'
  import InputWidget from '@/components/widgets/InputWidget'

  export default {
    name: 'Login',
    components: {InputWidget},
    data () {
      return {
        email: null,
        password: null,
        loading: false
      }
    },
    beforeCreate () {
      if (auth.getAccessToken()) {
        this.$router.push('/organization')
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.login()
          }
        })
      },
      login () {
        const {email, password} = this
        this.loading = true
        let data = {email: email, password: password}
        this.$api.post('/v1/auth/login', data).then(response => {
          let data = response.data
            /* Setting user in the state and caching record to the localStorage */
          if (data.access_token) {
            auth.login(data)
            this.$i18n.locale = auth.getLanguage()
            this.loading = false
            this.$router.push('/organization')
          }
        }).catch(error => {
          const message = error.response.data.error.message === 'OAUTH_EMAIL_NOT_VERIFIED'
            ? this.$t('message.loginFailedEmailVerify')
            : this.$t('message.loginFailed')
          this.$events.fire('message-open', {
            type: 'error',
            message: message
          })
          this.loading = false
        })
      },
      onFBLogin () {
        this.$router.push('/organization')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage/Login.vue